// source: installations.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.qotto.app_shs_cc.Installation', null, global);
goog.exportSymbol('proto.qotto.app_shs_cc.Installation.Country', null, global);
goog.exportSymbol('proto.qotto.app_shs_cc.Installation.FinancialCategory', null, global);
goog.exportSymbol('proto.qotto.app_shs_cc.Installation.FollowupCategory', null, global);
goog.exportSymbol('proto.qotto.app_shs_cc.InstallationsStore', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.qotto.app_shs_cc.Installation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.qotto.app_shs_cc.Installation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.qotto.app_shs_cc.Installation.displayName = 'proto.qotto.app_shs_cc.Installation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.qotto.app_shs_cc.InstallationsStore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.qotto.app_shs_cc.InstallationsStore.repeatedFields_, null);
};
goog.inherits(proto.qotto.app_shs_cc.InstallationsStore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.qotto.app_shs_cc.InstallationsStore.displayName = 'proto.qotto.app_shs_cc.InstallationsStore';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.qotto.app_shs_cc.Installation.prototype.toObject = function(opt_includeInstance) {
  return proto.qotto.app_shs_cc.Installation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.qotto.app_shs_cc.Installation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qotto.app_shs_cc.Installation.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractNo: jspb.Message.getFieldWithDefault(msg, 1, 0),
    country: jspb.Message.getFieldWithDefault(msg, 2, 0),
    installDate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reinstallDate: jspb.Message.getFieldWithDefault(msg, 4, 0),
    expirationReqDate: jspb.Message.getFieldWithDefault(msg, 5, 0),
    expirationAckDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastComDate: jspb.Message.getFieldWithDefault(msg, 7, 0),
    firstActivationDate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    bmsSn: jspb.Message.getFieldWithDefault(msg, 9, 0),
    scSn: jspb.Message.getFieldWithDefault(msg, 10, ""),
    gpsLat: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    gpsLon: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    avgPow7dProd: jspb.Message.getFieldWithDefault(msg, 13, 0),
    avgPow7dCons: jspb.Message.getFieldWithDefault(msg, 14, 0),
    clientName: jspb.Message.getFieldWithDefault(msg, 15, ""),
    clientMomoNumber: jspb.Message.getFieldWithDefault(msg, 16, ""),
    activationChart: jspb.Message.getFieldWithDefault(msg, 17, ""),
    activationRate: jspb.Message.getFieldWithDefault(msg, 18, 0),
    financialCategory: jspb.Message.getFieldWithDefault(msg, 19, 0),
    followupCategory: jspb.Message.getFieldWithDefault(msg, 20, 0),
    amountToRecover: jspb.Message.getFieldWithDefault(msg, 21, 0),
    zohoInstallId: jspb.Message.getFieldWithDefault(msg, 22, 0),
    zohoClientId: jspb.Message.getFieldWithDefault(msg, 23, 0),
    zohoContractId: jspb.Message.getFieldWithDefault(msg, 24, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.qotto.app_shs_cc.Installation}
 */
proto.qotto.app_shs_cc.Installation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.qotto.app_shs_cc.Installation;
  return proto.qotto.app_shs_cc.Installation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.qotto.app_shs_cc.Installation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.qotto.app_shs_cc.Installation}
 */
proto.qotto.app_shs_cc.Installation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractNo(value);
      break;
    case 2:
      var value = /** @type {!proto.qotto.app_shs_cc.Installation.Country} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstallDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReinstallDate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExpirationReqDate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExpirationAckDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLastComDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFirstActivationDate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBmsSn(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setScSn(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGpsLat(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGpsLon(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvgPow7dProd(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setAvgPow7dCons(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientMomoNumber(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivationChart(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivationRate(value);
      break;
    case 19:
      var value = /** @type {!proto.qotto.app_shs_cc.Installation.FinancialCategory} */ (reader.readEnum());
      msg.setFinancialCategory(value);
      break;
    case 20:
      var value = /** @type {!proto.qotto.app_shs_cc.Installation.FollowupCategory} */ (reader.readEnum());
      msg.setFollowupCategory(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAmountToRecover(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setZohoInstallId(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setZohoClientId(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setZohoContractId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.qotto.app_shs_cc.Installation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.qotto.app_shs_cc.Installation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.qotto.app_shs_cc.Installation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qotto.app_shs_cc.Installation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractNo();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getInstallDate();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getReinstallDate();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getExpirationReqDate();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getExpirationAckDate();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getLastComDate();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getFirstActivationDate();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getBmsSn();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getScSn();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGpsLat();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getGpsLon();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getAvgPow7dProd();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getAvgPow7dCons();
  if (f !== 0) {
    writer.writeSint32(
      14,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getClientMomoNumber();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getActivationChart();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getActivationRate();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getFinancialCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getFollowupCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getAmountToRecover();
  if (f !== 0) {
    writer.writeUint32(
      21,
      f
    );
  }
  f = message.getZohoInstallId();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getZohoClientId();
  if (f !== 0) {
    writer.writeUint64(
      23,
      f
    );
  }
  f = message.getZohoContractId();
  if (f !== 0) {
    writer.writeUint64(
      24,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.qotto.app_shs_cc.Installation.Country = {
  BENIN: 0,
  BURKINA: 1
};

/**
 * @enum {number}
 */
proto.qotto.app_shs_cc.Installation.FinancialCategory = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4
};

/**
 * @enum {number}
 */
proto.qotto.app_shs_cc.Installation.FollowupCategory = {
  C1: 0,
  C2: 1,
  C3: 2,
  C4: 3,
  C5: 4,
  C6: 5
};

/**
 * optional uint32 contract_no = 1;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getContractNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setContractNo = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Country country = 2;
 * @return {!proto.qotto.app_shs_cc.Installation.Country}
 */
proto.qotto.app_shs_cc.Installation.prototype.getCountry = function() {
  return /** @type {!proto.qotto.app_shs_cc.Installation.Country} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.qotto.app_shs_cc.Installation.Country} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 install_date = 3;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getInstallDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setInstallDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 reinstall_date = 4;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getReinstallDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setReinstallDate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 expiration_req_date = 5;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getExpirationReqDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setExpirationReqDate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 expiration_ack_date = 6;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getExpirationAckDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setExpirationAckDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 last_com_date = 7;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getLastComDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setLastComDate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 first_activation_date = 8;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getFirstActivationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setFirstActivationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 bms_sn = 9;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getBmsSn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setBmsSn = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string sc_sn = 10;
 * @return {string}
 */
proto.qotto.app_shs_cc.Installation.prototype.getScSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setScSn = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional float gps_lat = 11;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getGpsLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setGpsLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float gps_lon = 12;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getGpsLon = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setGpsLon = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional uint32 avg_pow7d_prod = 13;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getAvgPow7dProd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setAvgPow7dProd = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional sint32 avg_pow7d_cons = 14;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getAvgPow7dCons = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setAvgPow7dCons = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string client_name = 15;
 * @return {string}
 */
proto.qotto.app_shs_cc.Installation.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string client_momo_number = 16;
 * @return {string}
 */
proto.qotto.app_shs_cc.Installation.prototype.getClientMomoNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setClientMomoNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string activation_chart = 17;
 * @return {string}
 */
proto.qotto.app_shs_cc.Installation.prototype.getActivationChart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setActivationChart = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional uint32 activation_rate = 18;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getActivationRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setActivationRate = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional FinancialCategory financial_category = 19;
 * @return {!proto.qotto.app_shs_cc.Installation.FinancialCategory}
 */
proto.qotto.app_shs_cc.Installation.prototype.getFinancialCategory = function() {
  return /** @type {!proto.qotto.app_shs_cc.Installation.FinancialCategory} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.qotto.app_shs_cc.Installation.FinancialCategory} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setFinancialCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional FollowupCategory followup_category = 20;
 * @return {!proto.qotto.app_shs_cc.Installation.FollowupCategory}
 */
proto.qotto.app_shs_cc.Installation.prototype.getFollowupCategory = function() {
  return /** @type {!proto.qotto.app_shs_cc.Installation.FollowupCategory} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.qotto.app_shs_cc.Installation.FollowupCategory} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setFollowupCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional uint32 amount_to_recover = 21;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getAmountToRecover = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setAmountToRecover = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional uint64 zoho_install_id = 22;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getZohoInstallId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setZohoInstallId = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint64 zoho_client_id = 23;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getZohoClientId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setZohoClientId = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional uint64 zoho_contract_id = 24;
 * @return {number}
 */
proto.qotto.app_shs_cc.Installation.prototype.getZohoContractId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.qotto.app_shs_cc.Installation} returns this
 */
proto.qotto.app_shs_cc.Installation.prototype.setZohoContractId = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.qotto.app_shs_cc.InstallationsStore.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.qotto.app_shs_cc.InstallationsStore.prototype.toObject = function(opt_includeInstance) {
  return proto.qotto.app_shs_cc.InstallationsStore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.qotto.app_shs_cc.InstallationsStore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qotto.app_shs_cc.InstallationsStore.toObject = function(includeInstance, msg) {
  var f, obj = {
    installationsList: jspb.Message.toObjectList(msg.getInstallationsList(),
    proto.qotto.app_shs_cc.Installation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.qotto.app_shs_cc.InstallationsStore}
 */
proto.qotto.app_shs_cc.InstallationsStore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.qotto.app_shs_cc.InstallationsStore;
  return proto.qotto.app_shs_cc.InstallationsStore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.qotto.app_shs_cc.InstallationsStore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.qotto.app_shs_cc.InstallationsStore}
 */
proto.qotto.app_shs_cc.InstallationsStore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.qotto.app_shs_cc.Installation;
      reader.readMessage(value,proto.qotto.app_shs_cc.Installation.deserializeBinaryFromReader);
      msg.addInstallations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.qotto.app_shs_cc.InstallationsStore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.qotto.app_shs_cc.InstallationsStore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.qotto.app_shs_cc.InstallationsStore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qotto.app_shs_cc.InstallationsStore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstallationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.qotto.app_shs_cc.Installation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Installation installations = 1;
 * @return {!Array<!proto.qotto.app_shs_cc.Installation>}
 */
proto.qotto.app_shs_cc.InstallationsStore.prototype.getInstallationsList = function() {
  return /** @type{!Array<!proto.qotto.app_shs_cc.Installation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.qotto.app_shs_cc.Installation, 1));
};


/**
 * @param {!Array<!proto.qotto.app_shs_cc.Installation>} value
 * @return {!proto.qotto.app_shs_cc.InstallationsStore} returns this
*/
proto.qotto.app_shs_cc.InstallationsStore.prototype.setInstallationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.qotto.app_shs_cc.Installation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.qotto.app_shs_cc.Installation}
 */
proto.qotto.app_shs_cc.InstallationsStore.prototype.addInstallations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.qotto.app_shs_cc.Installation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.qotto.app_shs_cc.InstallationsStore} returns this
 */
proto.qotto.app_shs_cc.InstallationsStore.prototype.clearInstallationsList = function() {
  return this.setInstallationsList([]);
};


goog.object.extend(exports, proto.qotto.app_shs_cc);
